import { SelectItem } from 'primeng/api';
import { NgxUtility } from './utility';

export class NgxLambdaUtility {

    // get member name from expression
    // !!Experimental
    static getMemberNameFromExpression(callbackfn: string) {
        const methodBody = callbackfn.substring(callbackfn.indexOf('{') + 1, callbackfn.lastIndexOf('}'));
        // get only last part
        const splitItems = methodBody.split('.');
        // check length of split item
        if (splitItems.length === 2) {
            // last item and remove ;, which is added by method
            return splitItems[1].replace(';', '').trim();
        } else if (splitItems.length === 3) {
            // last item and remove ;, which is added by method
            return splitItems[2].replace(';', '').trim();
        }
        return null;
    }

    // to select items
    static toSelectItems<T>(items: T[], callbackfnValue: (value: T) => any, callbackfnLabel: (value: T) => any): SelectItem[] {
        const valueField = this.getMemberNameFromExpression(callbackfnValue.toString());
        const labelField = this.getMemberNameFromExpression(callbackfnLabel.toString());
        return NgxUtility.toSelectItems(items, valueField, labelField);
    }
}
